import { useCallback } from 'react';
import useGameStore from '../store/gameStore';

// Singleton AudioContext — creating a new one per sound call causes browsers
// to throttle or silently drop audio, especially during rapid auto-bet cycles.
let _ctx = null;
function getCtx() {
  if (!_ctx || _ctx.state === 'closed') {
    _ctx = new (window.AudioContext || window.webkitAudioContext)();
  }
  if (_ctx.state === 'suspended') _ctx.resume();
  return _ctx;
}

function createTone(freq, type = 'sine', duration = 0.15, gain = 0.3) {
  try {
    const ctx = getCtx();
    const osc = ctx.createOscillator();
    const g   = ctx.createGain();
    osc.connect(g);
    g.connect(ctx.destination);
    osc.type = type;
    osc.frequency.setValueAtTime(freq, ctx.currentTime);
    g.gain.setValueAtTime(gain, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + duration);
  } catch (_) { /* silent fail */ }
}

function playJingle(notes) {
  notes.forEach(([freq, delay, duration]) => {
    setTimeout(() => createTone(freq, 'triangle', duration, 0.25), delay);
  });
}

export function useSound() {
  const soundEnabled = useGameStore(s => s.soundEnabled);

  const play = useCallback((name) => {
    if (!soundEnabled) return;
    switch (name) {
      case 'drop':
        createTone(160, 'triangle', 0.18, 0.45);
        break;
      case 'step':
        // Two-tone hop: soft thud then bright tick
        createTone(420, 'triangle', 0.12, 0.35);
        setTimeout(() => createTone(680, 'triangle', 0.10, 0.28), 55);
        break;
      case 'win':      playJingle([[523,0,0.15],[659,120,0.15],[784,240,0.2],[1046,380,0.3]]); break;
      case 'cashout':  playJingle([[659,0,0.12],[784,100,0.12],[1046,200,0.25]]); break;
      case 'lose':     playJingle([[220,0,0.3],[180,200,0.3],[140,400,0.4]]); break;
      case 'click':    createTone(880, 'sine', 0.05, 0.15); break;
      default: break;
    }
  }, [soundEnabled]);

  return { play };
}
